import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.headerState || initialState;

export const selectDealersList = createSelector(
  [selectDomain],
  headerState => headerState.dealers,
);

export const selectDealerSelected = createSelector(
  [selectDomain],
  headerState => headerState.selectedDealer,
);

export const selectDealerSelectStatus = createSelector(
  [selectDomain],
  headerState => headerState.isDealerSelectEnabled,
);

export const selectDrawerOpen = createSelector(
  [selectDomain],
  headerState => headerState.isDrawerOpen,
);

